import { tamarackAPI, processApiResponse } from "./Tamarack";
import { fileStoreAPI } from "./FileStoreApi";

const postDocument = async (dataList, brokerId, email) => {
	const path = `document`+'?use-filename=true';
	tamarackAPI.setHeader("broker-id", brokerId);
	tamarackAPI.setHeader("email", email);
	const response = await tamarackAPI.post(path, dataList);
	if (response.status >= 200 && response.status < 400) return response.data;
	return processApiResponse(response, "post", path);
};

export const DocsDataAPI = {
	async fetchApplications(searchObj, brokerId, email) {
		if (searchObj && typeof searchObj !== "object") {
			throw new Error(
				"Search object must be key value type ex: {status: 'Funding'}"
			);
		}
		let searchCriteria = "";
		if (searchObj) {
			let keys = Object.keys(searchObj);
			searchCriteria = `?${keys[0]}=${searchObj[keys[0]]}`;
			for (let i = 1; i < keys.length; i++) {
				searchCriteria = `${searchCriteria}&${keys[i]}=${searchObj[keys[i]]}`;
			}
		}
		const path = `applications${searchCriteria}`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async fetchApplicationById(applicantId, brokerId, email) {
		const path = `application/${applicantId}`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		if (response.status === 404) throw new Error(response.data);
		return processApiResponse(response, "get", path);
	},

	async fetchApplicationGuarantorsById(applicantId, brokerId, email) {
		const path = `application/${applicantId}/guarantors`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async fetchBrokerAgencyID(brokerId) {
		const path = `broker/${brokerId}/`;
		tamarackAPI.setHeader("broker-id", brokerId);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async createAgencyPerson(dataList, brokerId) {
		const path = `agencyPerson`;
		tamarackAPI.setHeader("broker-id", brokerId);
		const response = await tamarackAPI.post(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "post", path);
	},
	async fetchApplicationFeeById(applicantId, brokerId, email) {
		const path = `application/${applicantId}/fees`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async fetchApplicationDealsById(applicantId, brokerId, email) {
		const path = `application/${applicantId}/dealStructures`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async fetchApplicationDocumentsById(applicationId, brokerId, email) {
		const path = `application/${applicationId}/documents`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async fetchApplicationAssetsById(applicantId, brokerId, email) {
		const path = `application/${applicantId}/assets`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async fetchApplicationLocationsById(applicationId, brokerId, email) {
		const path = `application/${applicationId}/locations`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async getApplicationFeesById(applicantId, brokerId, email) {
		const path = `application/${applicantId}/fees`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async getApplicationStateSalesTaxById(applicantId, brokerId, email) {
		const path = `application/${applicantId}/stateSalesTaxes`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async putStipulationSatisfy(dataList) {
		const path = `creditStipulation?action=satisfy`;
		const response = await tamarackAPI.put(path, dataList);
		return processApiResponse(response, "put", path);
	},
	async updateApplication(updatedApplication, brokerId, email) {
		const path = `application`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, updatedApplication);
		return processApiResponse(response, "put", path);
	},
	async getStipulationStaisfaction(appId) {
		const path = `creditStipulations?application_id=${appId}`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async putStipulationStaisfaction(dataList) {
		const path = `creditStipulation`;
		const response = await tamarackAPI.put(path, dataList);
		return processApiResponse(response, "put", path);
	},

	async postDocument(dataList, brokerId, email) {
		const path = `document`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.post(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "post", path);
	},

	async putDocument(payload, brokerId, email) {
		const path = `document`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, payload);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},

	async uploadDocumentToFileStore(
		appId,
		brokerId,
		selectedFile,
		fileType,
		rfiID,
		uploadedBy,
		assetID,
		payeeId,
		includeInFundingProof,
		email,
		checklistID
	) {
		const path = "/applications/" + appId + "?prefix=" + appId;
		const formData = new FormData();
		formData.append("file", selectedFile);
		fileStoreAPI.setHeader("Broker-Id", brokerId);
		if (email) fileStoreAPI.setHeader("email", email);
		fileStoreAPI.setHeader("Content-Type", "multipart/form-data");

		//uploading document to File Store
		const response = await fileStoreAPI.post(path, formData);
		const fileStoreURL = response.data;

		const document = {
			application_id: appId,
			document_name: selectedFile.name,
			type: fileType,
			related_to: "Lessee",
			notes: "Uploaded from FAST UI",
			azure_file_url: fileStoreURL,
			rfi: rfiID,
			uploaded_by_name: uploadedBy,
			asset: assetID,
			checklist_response: checklistID,
		};

		if (payeeId) {
			document.payee_id = payeeId;
			document.include_in_funding_proof = includeInFundingProof;
			document.notes = "Uploaded from Account Reconciliation in Redesign";
		}

		//Creating an attachment in DB with Azure File URL

		let documentId = await postDocument(document, "ALL", email);
		return documentId;
	},

	async uploadMultipleDocumentsToFileStore(
		appId,
		brokerId,
		selectedFile,
		fileType,
		rfiID,
		uploadedBy,
		assetID,
		payeeId,
		includeInFundingProof,
		email,
		checklistID
	) {
		const path = "/applications/" + appId + "?prefix=" + appId+'&use-filename=true';
		const formData = new FormData();
		formData.append("file", selectedFile);
		fileStoreAPI.setHeader("Broker-Id", brokerId);
		if (email) fileStoreAPI.setHeader("email", email);
		fileStoreAPI.setHeader("Content-Type", "multipart/form-data");

		//uploading document to File Store
		const response = await fileStoreAPI.post(path, formData);
		const fileStoreURL = response.data;

		const document = {
			application_id: appId,
			document_name: selectedFile.name,
			type: fileType ?? selectedFile.type ?? 'Funding Checklist',
			related_to: "Lessee",
			notes: "Uploaded from FAST UI",
			azure_file_url: fileStoreURL,
			rfi: rfiID,
			uploaded_by_name: uploadedBy,
			asset: assetID,
			checklist_response: checklistID,
		};

		if (payeeId) {
			document.payee_id = payeeId;
			document.include_in_funding_proof = includeInFundingProof;
			document.notes = "Uploaded from Account Reconciliation in Redesign";
		}

		//Creating an attachment in DB with Azure File URL

		let documentId = await postDocument(document, "ALL", email);
		return [documentId, fileStoreURL];
	},

	async getFileStoreURL(fileName, containerType, brokerId) {
		const path = `/download/${containerType}?filename=${encodeURIComponent(fileName)}`;
		const response = await fileStoreAPI.get(path, {}, { responseType: 'blob', ['Broker-Id']: brokerId });
		return processApiResponse(response, "get", path);
	},

	// async uploadDocumentToFileStore(appId, brokerId, selectedFile, selectedTypes) {

	// 	const formData = new FormData();
	// 	let AZURE_URL,
	// 		AUTH_TOKEN = "";
	// 	//Adds Auth Token
	// 	if (window.access_token) {
	// 		AUTH_TOKEN = `Bearer ${window.access_token}`;
	// 	} else if (window.id_token) {
	// 		AUTH_TOKEN = `Bearer ${window.id_token}`;
	// 	} else if (window.authProvider) {
	// 		const token = await window.authProvider.getAccessToken();
	// 		AUTH_TOKEN = `Bearer ${token.accessToken}`;
	// 	}
	// 	//Append the file in the form Data
	// 	formData.append("file", selectedFile);
	// 	var config = {
	// 		method: "post",
	// 		url: `${process.env.REACT_APP_FILESTORE_API_URL}/applications/${appId}`,
	// 		headers: {
	// 			"Broker-Id": brokerId,
	// 			"Content-Type": "multipart/form-data; ",
	// 			Authorization: AUTH_TOKEN,
	// 		},
	// 		data: formData,
	// 	};
	// 	//This api call returns the Azure URL
	// 	axios(config)
	// 		.then(async (res) => {
	// 			AZURE_URL = await res.data;
	// 			//This api call save the appliction data
	// 			await ApplicationRepo.saveApplicationDocForLessee(
	// 				appId,
	// 				selectedFile.name,
	// 				selectedTypes[0],
	// 				AZURE_URL
	// 			);
	// 			// Save Application Complete
	// 		})

	// 		.catch((err) => console.error("err", err));
	// },

	async postAttachment(dataList) {
		const path = `attachment`;
		const response = await tamarackAPI.post(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "post", path);
	},

	async getDocumentAttachment(parentId) {
		const path = `attachments?parent_id=${parentId}`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async putGuarantor(guarantorData, applicant) {
		const path = `application/${guarantorData[0].application_id}/guarantors`;
		tamarackAPI.setHeader("broker-id", applicant.broker_id);
		tamarackAPI.setHeader("email", applicant.locked_by_email);
		const response = await tamarackAPI.put(path, guarantorData);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},

	async getPrefundingVerbal(appId) {
		const path = `application/${appId}/preFundingVerbals`;
		const response = await tamarackAPI.get(path);
		console.log("check data -- ", response.data);
		console.log("object data -- ", typeof response.data);
		// if (response.status >= 200 && typeof response.data === "string") {
		//   return response.data;
		// }
		return processApiResponse(response, "get", path);
	},

	async getPrefundingGuarantor(appId) {
		const path = `preFundingGuarantors?application_id=${appId}`;
		const response = await tamarackAPI.get(path);
		console.log("Acces", response.status);
		return processApiResponse(response, "get", path);
	},

	async getGuarantorDetails(guarantorId, brokerId, email) {
		const path = `guarantor/${guarantorId}`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async getGpsInfo(assetId, brokerId, email) {
		const path = `asset/${assetId}/gpsInfos`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async getPreFundingActivityLogs(related_object_id) {
		const path = `preFundingActivityLogs?related_object_id=${related_object_id}`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async savePrefundingVerbal(prefundingVerbal) {
		console.log("update data -- ", prefundingVerbal);
		const path = `preFundingVerbal`;
		const response = await tamarackAPI.post(path, prefundingVerbal);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "post", path);
	},
	async savePrefundingGuarantor(prefundingGuarantor) {
		console.log("update data -- ", prefundingGuarantor);
		const path = `preFundingGuarantor`;
		const response = await tamarackAPI.post(path, prefundingGuarantor);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "post", path);
	},
	async saveGpsInfo(Gpsdata) {
		const path = `gps-info`;
		const response = await tamarackAPI.post(path, Gpsdata);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "post", path);
	},
	async updateGpsInfo(Gpsdata) {
		const path = `gps-info`;
		const response = await tamarackAPI.put(path, Gpsdata);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async getESignature(appId, brokerId, email) {
		const path = `application/${appId}/esignatures`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async deleteESignature(esignatureId) {
		const path = `esignature/${esignatureId}`;
		const response = await tamarackAPI.delete(path);
		return processApiResponse(response, "delete", path);
	},
	async postESignature(data) {
		const path = `esignature`;
		const response = await tamarackAPI.post(path, data);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "post", path);
	},
	async putESignature(data) {
		const path = `esignature`;
		const response = await tamarackAPI.put(path, data);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async getCreditAnalyses(application_id, status, brokerId, email) {
		const path = `creditAnalyses?application_id=${application_id}&status=${status}`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async deleteDocument(documentId, brokerId, email) {
		const path = `document/${documentId}`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.delete(path);
		return processApiResponse(response, "delete", path);
	},
	async deleteAttachment(attachmentId) {
		const path = `attachment/${attachmentId}`;
		const response = await tamarackAPI.delete(path);
		return processApiResponse(response, "delete", path);
	},
	async updatePrefundingVerbal(prefundingVerbal) {
		console.log("update prefunding verbal -- ", prefundingVerbal);
		const path = `preFundingVerbal`;
		const response = await tamarackAPI.put(path, prefundingVerbal);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async updatePrefundingGuarantor(prefundingGuarantor) {
		console.log("update prefunding Guarantor -- ", prefundingGuarantor);
		const path = `preFundingGuarantor`;
		const response = await tamarackAPI.put(path, prefundingGuarantor);
		if (response.status >= 200 && response.status < 400) return true;
		return processApiResponse(response, "put", path);
	},
	async getFunsingChecklistQsn(email) {
		const path = `fundingChecklistQuests`;
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async postFundingChecklistResp(dataList, email) {
		const path = `fundingChecklistResp`;
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.post(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "post", path);
	},

	async deleteFundingChecklistResp(fundingChecklistRespId) {
		const path = `fundingChecklistResp/${fundingChecklistRespId}`;
		const response = await tamarackAPI.delete(path);
		return processApiResponse(response, "delete", path);
	},

	async putFundingChecklist(dataList) {
		const path = `fundingChecklistResp`;
		const response = await tamarackAPI.put(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async getPurchasePriceDealStructure(appId, brokerId, email) {
		const path = `application/${appId}/purchasePriceDealStructures`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async postPurchasePriceDealStructure(dataList) {
		const path = `purchasePriceDealStructure`;
		const response = await tamarackAPI.post(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "post", path);
	},
	async putPurchasePriceDealStructure(dataList) {
		const path = `purchasePriceDealStructure`;
		const response = await tamarackAPI.put(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async deletePurchasePriceDealStructure(purchasePriceDealStructureId) {
		const path = `purchasePriceDealStructure/${purchasePriceDealStructureId}`;
		const response = await tamarackAPI.delete(path);
		return processApiResponse(response, "delete", path);
	},
	async updatePurchasePrice(brokerId, dataList, email) {
		const path = `creditAnalysis`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async getFundingChecklistResps(appId, email) {
		const path = `fundingChecklistResps?application_id=${appId}`;
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async putFundingChecklistResp(dataList, email) {
		const path = `fundingChecklistResp`;
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async getPurchasePriceAssetResps(creditAnalsisId) {
		const path = `purchasePriceAssets?credit_analysis=${creditAnalsisId}`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async postPurchasePriceAssetResps(dataList) {
		const path = `purchasePriceAsset`;
		const response = await tamarackAPI.post(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "post", path);
	},
	async deletePurchasePriceAssetResps(creditAnalsisId) {
		const path = `creditAnalysis/${creditAnalsisId}/purchasePriceAssets`;
		const response = await tamarackAPI.delete(path);
		return processApiResponse(response, "delete", path);
	},
	async getDocumentPackages() {
		const path = `documentPackages`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async enqueueDocGen(dataList, brokerId, email) {
		const path = `document?action=enqueueDocGen`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async sendToDocusign(dataList, brokerId, email) {
		const path = `document?action=sendToDocusign`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async resendToDocusign(dataList, brokerId, email) {
		const path = `document?action=resendToDocusign`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async updateDocusignEnv(dataList, brokerId, email) {
		const path = `document?action=updateDocusign`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async voidDocusign(dataList, brokerId, email) {
		const path = `document?action=voidDocusign`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async checkDocusignHistories(appId) {
		const path = `docusignHistories?application_id=${appId}`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async getAspireData(appId, action) {
		const path = `aspire/${appId}/${action}`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async getDeclineActionsList() {
		const path = `/picklistValues?object=application__c&field=decline_reason__c`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async getChecklistPicklistItems(field, email) {
		const path = `/picklistValues?object=funding_checklist_response__c&field=${field}`;
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async getFileTypeList() {
		const path = `picklistValues?object=document__c&field=type__c`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async putApplicationDealsById(dataList, appId) {
		const path = `purchasePriceDealStructure/${appId}`;
		const response = await tamarackAPI.put(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async getAmendmentsChanges() {
		const path = `picklistValues?object=Task&field=Amendment_List_of_Changes__c`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async getAmendmentTypes() {
		const path = `picklistValues?object=Task&field=Amendment_Type__c`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async getAmendments(appId) {
		const path = `amendments/${appId}`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async postAmendments(payload) {
		const path = `amendments`;
		const response = await tamarackAPI.post(path, payload);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "post", path);
	},
	async putAmendments(payload) {
		const path = `amendments`;
		const response = await tamarackAPI.put(path, payload);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	async generateAmendments(appId, version, email) {
		const path = `document?action=enqueueDocGen&version=${version}`;
		tamarackAPI.setHeader("Version-Number", "v2");
		tamarackAPI.setHeader("email", email);
		const payload = {
			application_id: appId,
			package_name: "Amendment",
		};
		const response = await tamarackAPI.put(path, payload);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},
	//Move to Deal maker
	async moveToDmCreditAnalysis(brokerId, email, payload) {
		const path = `creditAnalysis`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, payload);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "put", path);
	},

	async moveToDmDealStructure(brokerId, email, payload) {
		const path = `/dealStructure`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, payload);
		return processApiResponse(response, "put", path);
	},

	async moveToDmApplication(brokerId, email, payload) {
		const path = `/application`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, payload);
		if (response.status === 404) throw new Error(response.data);
		return processApiResponse(response, "put", path);
	},

	async sendEmail(dataList, brokerId, email) {
		const path = `sendmail`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.post(path, dataList);
		if (response.status >= 200 && response.status < 400) return response.data;
		return processApiResponse(response, "post", path);
	},

	async getDataRobotReport(applicantId, brokerId, email) {
		const path = `datarobot/${applicantId}`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async getTitleProcessedByList() {
		const path = `/picklistValues?object=Application_Asset__c&field=Title_Processed_by__c`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async getTitleStatusList() {
		const path = `/picklistValues?object=Application_Asset__c&field=Title_Status__c`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async getResubmitPicklistItems(email) {
		const path = `/picklistValues?object=Case&field=Resubmit_Reasons__c`;
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async uploadMultipleDocumentsToFileStoreResubmit(
		appId,
		brokerId,
		selectedFile,
		fileType,
		rfiID,
		uploadedBy,
		assetID,
		payeeId,
		includeInFundingProof,
		email,
		caseID
	) {
		const path = "/applications/" + appId + "?prefix=" + appId;
		const formData = new FormData();
		formData.append("file", selectedFile);
		fileStoreAPI.setHeader("Broker-Id", brokerId);
		if (email) fileStoreAPI.setHeader("email", email);
		fileStoreAPI.setHeader("Content-Type", "multipart/form-data");

		//uploading document to File Store
		const response = await fileStoreAPI.post(path, formData);
		const fileStoreURL = response.data;

		const document = {
			application_id: appId,
			document_name: selectedFile.name,
			type: fileType,
			related_to: "Lessee",
			notes: "Uploaded from FAST UI",
			azure_file_url: fileStoreURL,
			rfi: rfiID,
			uploaded_by_name: uploadedBy,
			asset: assetID,
			case_number: caseID,
		};

		if (payeeId) {
			document.payee_id = payeeId;
			document.include_in_funding_proof = includeInFundingProof;
			document.notes = "Uploaded from Account Reconciliation in Redesign";
		}

		//Creating an attachment in DB with Azure File URL

		let documentId = await postDocument(document, "ALL", email);
		return [documentId, fileStoreURL];
	},
};
